import { Modal } from 'antd';
import { Form } from '../Form';
import { CLOSE_ICON, ModalTitle } from './shared';
import { MODAL_STYLES } from './styled';

const STYLES = { ...MODAL_STYLES, body: { ...MODAL_STYLES.body, padding: '16px 18px' } };

export default function FormModal({
  title,
  subtitle,
  icon,
  head,
  enterSubmits = true,
  okText,
  okIcon,
  valid = true,
  loading,
  width = 520,
  top = 88,
  footer,
  onSubmit,
  onClose,
  children
}) {
  const submit = (e) => {
    e?.preventDefault();
    if (valid) onSubmit();
  };

  return (
    <Modal
      open
      zIndex={1100}
      width={width}
      style={{ top, paddingBottom: 0 }}
      styles={STYLES}
      closeIcon={CLOSE_ICON}
      title={
        <ModalTitle title={title} subtitle={subtitle} icon={icon} form>
          {head}
        </ModalTitle>
      }
      okText={okText}
      onCancel={onClose}
      onOk={() => submit()}
      confirmLoading={loading}
      okButtonProps={{ disabled: !valid, icon: okIcon }}
      footer={footer}
    >
      <Form as="form" onSubmit={submit}>
        {children}
        {enterSubmits && <button type="submit" hidden />}
      </Form>
    </Modal>
  );
}
